import { useQuery } from '@tanstack/react-query';
import { AppContext } from '../../../App';
import { useContext } from 'react';
import useGlynt from '../../hooks/useGlynt';
import { MatFieldsInfoResponse } from '../../../types/mat-types';

export function useMatFieldsInfo() {
  const { orgId } = useContext(AppContext);
  const glynt = useGlynt();
  return useQuery({
    queryKey: ['mat', 'fields-info', orgId],

    queryFn: async () => {
      const g = await glynt;
      if (!orgId) throw new Error('Missing orgId');
      return g.mat.fieldsInfo(orgId);
    },

    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: 0
  });
}

export default useMatFieldsInfo;
